import { Component, forwardRef, OnInit, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import E from 'wangeditor';

@Component({
  selector: 'app-d-ueditor',
  templateUrl: './d-ueditor.component.html',
  styles: [``],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DUeditorComponent),
      multi: true
    }
  ]
})
export class DUeditorComponent extends DynamicComponentBase implements AfterViewInit, OnDestroy {
  @ViewChild('editerDom') editerDom;
  value: string;
  ueditorConfig: Record<string, unknown>;
  loading: string;
  delay: number;
  static KEY = 'd-ueditor';
  editor;

  constructor() {
    super();
  }
  ngOnDestroy(): void {
    if (this.editor) {
      this.editor.destroy();
    }
    this.editor = null;
  }
  ngAfterViewInit(): void {
    this.createEditor();
  }

  configChange(config: IDynamicComponentConfig) {
    this.createEditor();
  }
  createEditor() {
    setTimeout(() => {
      if (this.config.name && this.editerDom && !this.editor) {
        this.editor = new E(`#${this.config.name}`);
        this.editor.config.zIndex = 99;
        this.editor.config.focus = false;
        this.editor.create();
      }
    }, 0);
  }
}
